import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';
import { defineMessages, useIntl } from '@atlas/text';

export const messages = defineMessages({
    moon: { id: 'lblIconMoon', defaultMessage: 'Moon' },
});

const MoonIcon = React.memo(function MoonIcon(props: TMoonIconProps): React.ReactElement {
    const intl = useIntl();

    return (
        <IconBase aria-label={intl.formatMessage(messages.moon)} {...props}>
            <path d="M12.997 4.059c-.276-1.344 1.416-2.208 2.332-1.157l1.416 1.627c6.973 8.006-3.993 19.026-12.033 12.093l-1.65-1.424c-1.05-.905-.21-2.614 1.148-2.335 5.234 1.076 9.863-3.566 8.787-8.804Zm1.777.727c.496 5.593-4.23 10.342-9.824 9.855l.843.727c6.484 5.592 15.328-3.296 9.704-9.752l-.723-.83Z" />
        </IconBase>
    );
});

export default MoonIcon;

// #region Types

export type TMoonIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <MoonIcon /> : { ...IconBaseExample, render: MoonIcon };

// #endregion
